import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  const whatsappNumber = '+351968382742';
  const message = 'Hello! I\'m interested in your padel holiday experiences in the Algarve.';
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, duration: 0.3 }}
      className="fixed bottom-8 right-8 z-50 bg-[#8ca87c] text-[#f5f3ee] w-14 h-14 flex items-center justify-center shadow-lg hover:bg-[#414b3b] transition-all duration-300"
      data-testid="whatsapp-button"
    >
      <MessageCircle size={24} />
    </motion.a>
  );
};

export default WhatsAppButton;
